import { render } from "./PendingCases.vue?vue&type=template&id=4514221c"
import script from "./PendingCases.vue?vue&type=script&lang=js"
export * from "./PendingCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/PendingCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4514221c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4514221c', __exports__)) {
    console.log('reload')
    api.reload('4514221c', __exports__)
  }
  
  module.hot.accept("./PendingCases.vue?vue&type=template&id=4514221c", () => {
    console.log('re-render')
    api.rerender('4514221c', render)
  })

}


export default __exports__